import { app } from '../../../app';
import { updates } from './updates';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.whats-new', {
        url: '/whats-new/:updateId',
        params: {updateId: updates[0].id},
        component: 'companyWhatsNew',
        resolve: {
            updateId,
        },
    });
}

/** @ngInject */
function updateId($stateParams) {
    return $stateParams.updateId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/whats-new/whats-new.state.js